import React from 'react'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { AdvertisingBanner } from '@/components/resolvers'
import { GlassMorphIcon, InjectHtml } from '@/components/ui'
import type { IBenefitsProps } from './interfaces'
import { messages } from './messages'
import './styles.scss'

const LandingBenefits: React.FC<IBenefitsProps> = props => {
  const {
    titleText = messages.defaultTitle,
    titleTextId = messages.defaultTitle,
    titleClassName,
    benefits,
    bannerBenefits,
    backgroundColor = 'white',
    bannerTitleText,
    bannerTitleTextId,
    bannerButtonText = messages.defaultButtonText,
    bannerBackgroundImage = '',
    onActionClick,
    blockId,
    shouldShowBannerBeforeTitle = false,
    titleSize,
    titleSizeXs = 5,
    sectionId,
    buttonTooltipMessage,
    withoutBanner,
    className,
    children,
    isSmallBannerButton,
  } = props

  const banner = !withoutBanner && (
    <div className="landing-benefits-banner-wrapper">
      <div className="page-wrapper page-wrapper_no-mobile">
        {(bannerTitleTextId || bannerTitleText) && (
          <AdvertisingBanner
            className={classNames(
              'landing-benefits-banner',
              shouldShowBannerBeforeTitle ? 'space-holder88-from-sm space-holder56-sm' : 'space-holder-top88-from-sm space-holder-top56-sm',
            )}
            buttonText={bannerButtonText}
            title={bannerTitleText}
            titleId={bannerTitleTextId}
            backgroundImage={bannerBackgroundImage}
            titleSize={titleSize}
            titleSizeXs={titleSizeXs}
            onButtonClick={onActionClick}
            benefits={bannerBenefits}
            isSlimBlock
            buttonTooltipMessage={buttonTooltipMessage}
            isButtonSmall={isSmallBannerButton}
          />
        )}
      </div>
    </div>
  )

  return (
    <section
      className={classNames(className, `background_${backgroundColor} landing-benefits-block`, {
        'landing-benefits-block_with-bottom-banner': (bannerTitleTextId || bannerTitleText) && !shouldShowBannerBeforeTitle,
      })}
      id={sectionId}
    >
      {shouldShowBannerBeforeTitle && banner}

      <div className="page-wrapper landing-benefits-wrapper">
        <h2 className={classNames('space-holder64-from-sm space-holder40-sm landing-benefits-block__title', titleClassName)}>
          {titleText ?? <FormattedMessage id={titleTextId} />}
        </h2>

        {children}

        <div className="landing-benefits row row-justify_between" id={blockId}>
          {benefits.map((benefit, index) => {
            const { icon, description, descriptionTagName = 'h5', title, titleTagName = 'h3', text } = benefit

            return (
              <div
                className={classNames(classNames('landing-benefit', { row: Boolean(description) }))}
                key={`${index}_${description || title || text}`}
              >
                <GlassMorphIcon image={icon} />
                <div>
                  {description && (
                    <div className="landing-benefit__description-wrapper">
                      <InjectHtml
                        textId={description}
                        TagName={descriptionTagName}
                        className="landing-benefit__description space-holder-left24-sm"
                      />
                    </div>
                  )}
                  {title && (
                    <InjectHtml textId={title} TagName={titleTagName} className="landing-benefit__title space-holder-top8 space-holder8" />
                  )}
                  {text && <InjectHtml textId={text} className="landing-benefit__text" />}
                </div>
              </div>
            )
          })}
        </div>
      </div>

      {!shouldShowBannerBeforeTitle && banner}
    </section>
  )
}

export default LandingBenefits
